import script from "./Info.vue?vue&type=script&setup=true&lang=js"
export * from "./Info.vue?vue&type=script&setup=true&lang=js"

import "./Info.vue?vue&type=style&index=0&id=c518bb2a&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c518bb2a"]])

export default __exports__